import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BaseEntity } from 'src/app/tools/models/baseEntity';

@Component({
    selector: 'lean-widget',
    templateUrl: './lean-widget.component.html',
    styleUrls: ['./lean-widget.component.scss']
})
export class LeanWidget implements OnInit {


    deleteMode              : boolean = false;
    shrinkMode              : boolean = false;

    @Output() onClose    = new EventEmitter<any>();
    @Output() onEdit     = new EventEmitter<any>();
    @Output() onAdd      = new EventEmitter<any>();
    @Output() onValidate = new EventEmitter<any>();
    @Output() onDelete   = new EventEmitter<any>();

    @Input() row            : BaseEntity = new BaseEntity();
    @Input() readOnly       : boolean = false;
    @Input() title          : string = undefined;
    @Input() allowShrink    : boolean = false;
    @Input() hideCloseButton: boolean = false;
    @Input() width          : string;

    

    @Input() badgeCls   = '';
    @Input() badge      = undefined;

    @Input() hideHeader : boolean = false;
    @Input() hideFooter : boolean = false;
    
    constructor(
        protected translate   : TranslateService,
        protected toastr      : ToastrService
    ){

    }
    ngOnInit() {
    }
    
    addNew() {
        this.onAdd.emit(true);
    }
    edit() {
        this.onEdit.emit(true);
    }

    cancel() {
        this.onEdit.emit(false);
    }

    validate(){
       this.onValidate.emit(false);
    }
    delete(){
        this.deleteMode = true;
     }
     deleteConfirm(){
        this.onDelete.emit(false);
     }
     deleteCancel(){
        this.deleteMode= false;
     }

    close(){

        if (this.row.edit){
            this.toastr.error("Vous êtes en mode édition. Prière de valider ou annuler l'édition en cours avant de quitter cette page.");
            return;
        }

        this.onClose.emit(null);
    }

    shrink(b : boolean){
        this.shrinkMode = b;
    }

    readMode() : boolean {
    //    return this.editMode != 'R';
        return ! this.row.edit;
    }
}
